import { IoChevronBack } from "react-icons/io5";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAtom } from 'jotai';
import { customerAtom } from '../auth';
import { Post } from '../compornents/Post';
import { Analytics } from '../compornents/Analytics';
import { toast } from 'react-toastify';

// 改定利用規約への再同意（ソフト導線）。販促配信は明示オプトイン（既定OFF）。
export const Reagree = () => {
  const navigate = useNavigate();
  const [, setCustomer] = useAtom(customerAtom);
  const [optin, setOptin] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setTimeout(() => { window.scrollTo(0, 0); }, 10);
  }, []);

  const back = () => navigate(-1);

  const agree = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await Post('post', '/customer/agree_terms.php', { is_marketing_optin: optin ? 1 : 0 });
      if (res.result === 1) {
        if (res.customer) setCustomer(res.customer);
        toast.success('ご同意ありがとうございます');
        navigate('/home');
      } else {
        toast.error(res.error_message || '同意の記録に失敗しました');
      }
    } catch (e) {
      toast.error('通信に失敗しました');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="App">
      <div className="Rule">
        <Analytics title="規約改定のお知らせ" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}><IoChevronBack /></div>
          <div className="toolbar_center">規約改定のお知らせ</div>
          <div className="toolbar_right"></div>
        </div>
        <div className="content px-3">
          <div className="h5 mb-3">利用規約・プライバシーポリシーを改定しました</div>
          <div className="mb-3">
            このたび、SMS・電子メール・LINE・アプリ内通知等による
            <strong>ご連絡および情報配信に関する条項</strong>を追加しました。
            引き続きご利用いただくため、内容をご確認のうえご同意をお願いいたします。
          </div>
          <div className="mb-3" style={{ fontSize: 14, color: '#555' }}>
            ・ご注文・集配・本人確認・重要なお知らせ等、サービス提供に必要なご連絡を行います。<br />
            ・クーポンやキャンペーン等の<strong>販促・お知らせ</strong>は、<strong>受信を希望された方にのみ</strong>配信します（下記でご選択ください）。マイページからいつでも停止できます。
          </div>
          <div className="mb-3">
            <Link to="/rule">利用規約はこちら</Link>　/　<Link to="/privacy">プライバシーポリシーはこちら</Link>
          </div>

          <label className="d-flex align-items-center mb-4" style={{ gap: 8, cursor: 'pointer' }}>
            <input type="checkbox" checked={optin} onChange={(e) => setOptin(e.target.checked)} />
            <span>お得なクーポン・キャンペーン・お知らせを受け取る（任意・SMS／メール）</span>
          </label>
        </div>
        <div className="flex_div3 border-top">
          <div className="p-3 pb-4">
            <button className="btn btn-oval btn-yellow form-control" onClick={agree} disabled={busy}>
              {busy ? '送信中…' : '同意して続ける'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
